<template> 
  <div>    
    <barraprincipal @abrir="mtMenuVisible"></barraprincipal>   
    <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>  

    <v-container fluid> 

        <div class="claro elevation-5">
            <v-row dense>     
                <v-col cols="12" md="12" class="d-flex align-center px-4">
                    <h2 class="primary--text">{{titulo}}</h2>  
                </v-col>                    
            </v-row>
        </div> 

        <br>                 

        <v-row v-if="tramites_alumno.length < 1">
            <v-col cols="12" class="d-flex justify-center">
                <v-img src="../../assets/sin_elementos.svg" max-width="150px" max-height="150px"></v-img>
            </v-col>
        </v-row>

        <v-row v-if="tramites_alumno.length == 0" dense>
            <v-col cols="12" class="d-flex justify-center">
                <span class="headline teal--text">No se encontraron elementos.</span>
            </v-col>
        </v-row>

        
        <v-expansion-panels hover >        
            
            <v-expansion-panel v-for="(tramite, key) in tramites_alumno" v-bind:key="key" @click="estatus_tramite(tramite.calumnoproceso)">
                
                <v-expansion-panel-header :color="tramite.estatus == 1 ? 'light-blue lighten-5' : 'teal lighten-5' ">
                    
                    <v-row>
                        <v-col>
                            <div class="mt-2 mb-2"><strong>Trámite:</strong> {{ tramite.nombre }}    </div>                        
                            <v-spacer></v-spacer>
                            <div class="mt-2 mb-2"><strong>Solicitado:</strong> {{ tramite.fecha_sol }} {{tramite.hora_sol}}</div>
                            <v-spacer></v-spacer>
                            <div class="mt-2 mb-2"><strong>Estatus: </strong><span v-if="tramite.estatus == 1" class="blue--text">Terminado</span><span v-else class="green--text">Activo</span> </div>                          
                        </v-col>                           
                    </v-row>
                 
                </v-expansion-panel-header>
                    
                <v-expansion-panel-content >  

                    <v-row v-if="tramite.estatus==0" class="mt-2" dense>
                        <v-col cols="12" class="d-flex">
                            <small><strong>EST:</strong> Estudiante. <strong>DEP:</strong> División de estudios profesionales. <strong> DSE:</strong> Departamento de servicios escolares.</small>
                            <v-spacer></v-spacer>
                            
                            <v-btn color="success"  @click="estatus_tramite(tramite.calumnoproceso)"><v-icon>mdi-refresh</v-icon></v-btn>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn :loading='descargando' color="primary" dense @click.stop="descarga(tramite.calumnoproceso)" v-if="tramite.nombre == 'Solicitud a Comité Académico'">Descargar Solicitud</v-btn>
                        </v-col>
                    </v-row>

                    <v-timeline dense clipped >
                        
                        <v-timeline-item v-for="(paso, idx) in tramite_pasos" :key="idx" fill-dot :color="colorPaso(paso.estatus)" > 
                            <template v-slot:icon>                         
                                <strong v-if="paso.estatus == 0" class="white--text">{{paso.orden}}</strong>
                                <v-icon v-if="paso.estatus == 1" color="white">mdi-check</v-icon>                                   
                                <v-icon v-if="paso.estatus == 2" color="white">mdi-close-thick</v-icon>                                   
                            </template>
                            
                            <v-row dense>
                                <v-col cols="12">
                                    <strong>{{paso.descripcion}}</strong>
                                </v-col>
                                <v-col><small><strong>Comentarios:</strong></small></v-col>
                                <v-col cols="12" class="body-1">
                                    <v-alert text  dense color="deep-orange darken-4" border="left">{{paso.comentarios}}</v-alert>                                   
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col>
                                    <small class="pl-5"><strong>Actualización:</strong> {{paso.fecha_act}}  {{paso.hora_act}} </small>                                  
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>

                        </v-timeline-item>    

                    </v-timeline>       

                    <v-alert color="primary" type="info" dense v-if="tramite.estatus == 1">Este trámite ha finalizado.</v-alert>
                   
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>       

    </v-container>

  </div>
</template>

<script>

import menulateral from '@/components/MenuLateral'
import barraprincipal from '@/components/BarraPrincipal'


export default {
    components:{
        menulateral,
        barraprincipal
    },
    data() {
        return {
            menu_visible: false,
            
            titulo: 'Estatus de trámites',

            tramites_alumno: [],
            tramite_pasos: [],
            tramite_actual: 0,

            descargando: false,
        }
    },

    mounted() {    
       
        const token = sessionStorage.getItem('data')

        this.axios.get(this.$url+'/tramites/listado', {headers: {Authorization: `Bearer ${token}`}})
            .then( (response) => {
                if(response.data){
                    this.tramites_alumno = response.data
                }
                else{
                    //Alerta de no se pudo recuperar información
                }
            })       
         
    },


    methods: {  
        mtMenuVisible(value){
            this.menu_visible = value
        },

        colorPaso(estatus){
            if(estatus == 0)
                return "blue"
            else if(estatus == 1)
                return "green" 
            else if(estatus == 2)
                return "red"
        },      

       estatus_tramite(ctramite){

           const token = sessionStorage.getItem('data')

            this.tramite_actual = ctramite

            this.axios.get(this.$url+'/tramites/detalle/'+ctramite, {headers:{Authorization: `Bearer ${token}`}})
                .then( (response) => {                    
                    if(response.data){                       
                        this.tramite_pasos = response.data
                    }
                    else{
                        //Alerta de no se pudo recuperar información
                    }
                })   
                .catch((error)=>{
                    console.log("Error "+error);
                })  
                
       },

       descarga(calumnoproceso){

            const datos = {
                calumnoproceso: calumnoproceso
            }

            this.descargando = true

            this.axios.post(this.$url+"/procesos/comiteacademico/solicitud-formato", datos,
                    {                                
                        responseType: 'blob'
                    })
        
                .then((response)=>{  

                    if(response.data.error)
                        return

                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
                .finally(()=>{
                    this.descargando = false
                })
                              
                
        },
    },
  
};

</script>